import { Card, Text } from '@magicschool/spellbook';
import { getStudentUrl } from '@magicschool/utils/nextjs/url';
import Image from 'next/image';
import { FormattedMessage } from 'react-intl';
import { useStore } from '@/features/store';
import { analyticsTrack } from '@/util/amplitude/analyticsClient';
import { LegalInfoClient } from './LegalInfoClient';

type RoleCardProps = {
  href?: string;
  icon: string;
  onClick: () => void;
  userRole: 'student' | 'educator';
};

const RoleCard = ({ href, icon, userRole, onClick }: RoleCardProps) => {
  const Comp = href ? 'a' : 'button';

  return (
    <Card className="p-6 sm:p-12 items-center justify-center" variant="interactive" onClick={onClick} asChild>
      <Comp href={href}>
        <Card.Content className="flex flex-col items-center justify-center gap-3 sm:gap-6">
          <Image className="h-24 sm:h-35 w-auto" src={`/icons/icon-${icon}.svg`} alt="" width={140} height={140} />
          <div className="flex flex-col sm:gap-2 items-center text-center">
            <Text variant="heading-3" element="h2">
              <FormattedMessage id={`signup-role.${userRole}-card.title`} />
            </Text>
            <Text variant="body-2" className="text-balance font-semibold">
              <FormattedMessage id={`signup-role.${userRole}-card.body`} />
            </Text>
          </div>
        </Card.Content>
      </Comp>
    </Card>
  );
};

export const RoleStep = () => {
  const setField = useStore(({ AuthFormStoreData: af }) => af.setField, []);

  const handleStudentClick = () => {
    analyticsTrack('SignIn:StudentRoleClicked');
  };

  const handleEducatorClick = () => {
    setField('roleSelected')(true);
  };

  return (
    <div className="flex flex-col items-center w-full max-w-xl gap-6">
      <Text className="text-center text-balance" variant="display-1">
        <FormattedMessage id="signup-role.header" />
      </Text>
      <div className="w-full max-w-xl grid sm:grid-cols-2 gap-3 sm:gap-10 mb-6">
        <RoleCard href={getStudentUrl()} icon="backpack-2" onClick={handleStudentClick} userRole="student" />
        <RoleCard icon="lockbox" onClick={handleEducatorClick} userRole="educator" />
      </div>
      <LegalInfoClient location="RoleStep" />
    </div>
  );
};
